import React from 'react';

import {ClickEvent, Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Button, Image} from '@udemy/react-core-components';
import {udLink} from '@udemy/ud-data';

import styles from './community-section.module.less';

export const CommunitySection = () => {
    const {gettext} = useI18n();

    const onClick = (componentName: string) => () => {
        Tracker.publishEvent(new ClickEvent({componentName}));
    };

    return (
        <div className="section" data-purpose="community-section">
            <div className="section-column image-container">
                <Image
                    className="placeholder-image"
                    src={udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/helping-through-teaching-v3.jpg',
                    )}
                    srcSet={`${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/helping-through-teaching-v3.jpg',
                    )} 1x, ${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/helping-through-teaching-2x-v3.jpg',
                    )} 2x`}
                    width={450}
                    height={450}
                    data-purpose="section-image"
                    alt=""
                />
            </div>
            <div className="section-column">
                <h2
                    className="ud-heading-serif-xxl section-title"
                    data-purpose="community-section-title"
                >
                    {gettext('Share your knowledge')}
                </h2>
                <p className="ud-text-md section-text">
                    {gettext(
                        'Real-world experts like you make a global impact by teaching on Udemy. ' +
                            'We believe everyone has something to offer. ' +
                            'Share your unique skills and experiences with students around the world ' +
                            'by teaching a free or paid course.',
                    )}
                </p>
                <div data-purpose="section-cta-wrapper" className={styles['link-wrapper']}>
                    <div>
                        <Button
                            componentClass="a"
                            data-purpose="section-cta"
                            href="https://www.udemy.com/teaching/"
                            className={styles['link']}
                            onClick={onClick('BecomeInstructor')}
                        >
                            {gettext('Become an instructor')}
                        </Button>
                    </div>
                    <div>
                        <Button
                            componentClass="a"
                            data-purpose="section-cta"
                            udStyle="secondary"
                            href="https://community.udemy.com/t5/Instructor-Community/ct-p/Community"
                            className={styles['link']}
                            onClick={onClick('JoinCommunity')}
                        >
                            {gettext('Join the community')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
